export class ActiveInsuranceGroup {
  position: number;
  name: string;
  nameTranslation?: string;
  lobIds: number[];
  icon: string;
  count?: number;
  cols?: number;
}
